/* eslint-disable max-len */
import merge from 'deepmerge';
import {
  localizedStrings as commonLocalizedStrings,
  STRING_KEYS as DEFINED_STRING_KEYS,
} from './common';
import { localizedStrings as flowLocalizedStrings } from './flow';
import { overwriteMerge } from '../utils/general';

export const STRING_KEYS = DEFINED_STRING_KEYS;

export const getSpecificLocalizedStringsObj = (flowName, userType, mainSelection, isSelfEmployed = false) => {
  let flowCommonLocalizedStrings = {};

  if (flowLocalizedStrings[flowName]) {
    if (flowLocalizedStrings[flowName].common) {
      flowCommonLocalizedStrings = flowLocalizedStrings[flowName].common;
    }

    let flowNUserTypeLocalizedStrings = {};
    if (flowLocalizedStrings[flowName][`user_${userType}`]) {
      flowNUserTypeLocalizedStrings = flowLocalizedStrings[flowName][`user_${userType}`];
      flowCommonLocalizedStrings = merge(flowCommonLocalizedStrings, flowNUserTypeLocalizedStrings, { arrayMerge: overwriteMerge });
    }

    let flowNSelfEmployedLocalizedStrings = {};
    if (isSelfEmployed && flowLocalizedStrings[flowName].selfEmployed) {
      flowNSelfEmployedLocalizedStrings = flowLocalizedStrings[flowName].selfEmployed;
      flowCommonLocalizedStrings = merge(flowCommonLocalizedStrings, flowNSelfEmployedLocalizedStrings, { arrayMerge: overwriteMerge });
    }
  }

  let commonUserTypeLocalizedStrings = {};

  if (commonLocalizedStrings[[`user_${userType}`]]) {
    commonUserTypeLocalizedStrings = commonLocalizedStrings[[`user_${userType}`]];
  }

  let finalCommonLocalizedStrings = merge(commonLocalizedStrings.common, commonUserTypeLocalizedStrings);

  if (isSelfEmployed && commonLocalizedStrings.selfEmployed) {
    finalCommonLocalizedStrings = merge(finalCommonLocalizedStrings, commonLocalizedStrings.selfEmployed);
  }

  let localizedStringsObj = merge(finalCommonLocalizedStrings, flowCommonLocalizedStrings, { arrayMerge: overwriteMerge });

  if (!mainSelection || !localizedStringsObj[`mainSelection_${mainSelection}`]) {
    return localizedStringsObj.everyMainSelection;
  }

  localizedStringsObj = merge(localizedStringsObj.everyMainSelection, localizedStringsObj[`mainSelection_${mainSelection}`]);

  return localizedStringsObj;
};
